import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, FileText, Mountain, Crown, Layers, Plus } from 'lucide-react';
export function ComparePage() {
  const [showEdge, setShowEdge] = useState(false);
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans pb-24" data-id="element-620" data-mp="dhwa376ktw4s">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-16 px-6 md:px-12 max-w-5xl mx-auto text-center" data-id="element-621" data-mp="3htqhvplvdd31">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-[#7FE0C3]/5 blur-[120px] rounded-full pointer-events-none" data-id="element-622" data-mp="3cv6sff82hj5x" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-623" data-mp="3qvhiig1jytq1">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-624" data-mp="115e6xh4p7kem">
            Your Partnership Options
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-625" data-mp="38tir592ktany">
            <button type="button" onClick={() => setShowEdge(isVisible => !isVisible)} aria-pressed={showEdge} aria-label={`${showEdge ? 'Show two' : 'Show three'} ways to partner`} className="inline-flex items-center rounded-lg text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7FE0C3] focus-visible:ring-offset-4 focus-visible:ring-offset-[#0A0F1C]" data-id="element-626" data-mp="3dtenqn8y1zth">
              {showEdge ? 'Three' : 'Two'}
            </button>{' '}
            Ways to Partner
          </h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-627" data-mp="2zvghy68ovbpl">
            A simple side-by-side of everything we discussed, so you can review
            the investment and share it with your team. Every package runs the
            HIRE recruiting system at a different level of ownership and
            execution.
          </p>
        </motion.div>
      </section>

      {/* 2. CORE PACKAGES */}
      <section className={`px-6 md:px-12 ${showEdge ? 'max-w-7xl' : 'max-w-5xl'} mx-auto mb-8 transition-[max-width] duration-300`} data-id="element-628" data-mp="2926lnqww4tcl">
        <div className={`grid grid-cols-1 gap-6 items-stretch ${showEdge ? 'md:grid-cols-3' : 'md:grid-cols-2'}`} data-id="element-629" data-mp="244eooihe2h1j">
          {showEdge && <motion.article initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.25
        }} className="bg-slate-900/40 border border-slate-600 rounded-2xl p-8 flex flex-col relative" data-id="element-630" data-mp="1ccfiz4eg3zvp">
              <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-631" data-mp="31qvk1i6kakkn">
                <div className="p-2 bg-slate-800 border border-slate-700 rounded-lg" data-id="element-632" data-mp="31syh2m64tdyv">
                  <Layers className="w-6 h-6 text-slate-300" data-id="element-633" data-mp="2wr96t8qqh4bu" />
                </div>
                <h2 className="text-2xl font-bold text-white" data-id="element-634" data-mp="ij882li990bi">Edge</h2>
              </div>
              <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-635" data-mp="nk5mqo423c89">
                A managed recruiting infrastructure layer for teams that keep
                hiring, onboarding, and training in-house.
              </p>

              <div className="mb-6" data-id="element-636" data-mp="eioa5fpuxsob">
                <div className="flex items-end justify-between mb-5" data-id="element-637" data-mp="1288x09p4ta2v">
                  <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-638" data-mp="12a3flhcxkq3s">
                    Build (One-Time)
                  </span>
                  <span className="text-2xl font-bold text-white" data-id="element-639" data-mp="siz1skyzrbaj">$3,000</span>
                </div>
                <div className="flex items-end justify-between" data-id="element-640" data-mp="xgh1dkr4ce5v">
                  <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-641" data-mp="1l6uwjk502t4o">
                    Total Monthly
                  </span>
                  <span className="text-2xl font-bold text-white" data-id="element-642" data-mp="1pymnhvs2j0vc">$2,500</span>
                </div>
                <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-643" data-mp="1ctk5tzblci5">
                  <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-644" data-mp="3sha1ug8pit7i">
                    What makes up the monthly
                  </div>
                  <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-645" data-mp="3jhmyvq0bxfcc">
                    <li className="flex justify-between" data-id="element-646" data-mp="k28gjb429dg7">
                      <span data-id="element-647" data-mp="k1qcvtf2jwy9">System fee</span>
                      <span data-id="element-648" data-mp="g0mzreoeof0q">$1,500</span>
                    </li>
                    <li className="flex justify-between" data-id="element-649" data-mp="g1g5qdfjj0ht">
                      <span data-id="element-650" data-mp="b94tqc7izo8w">Full campaign</span>
                      <span data-id="element-651" data-mp="b7tsaj1jysky">$1,000</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-652" data-mp="13pz3w04vlww6">
                <div className="flex items-baseline justify-between gap-3" data-id="element-653" data-mp="13sbvz64clnmy">
                  <span className="text-xs font-bold uppercase tracking-widest text-slate-400" data-id="element-654" data-mp="yxxwarinkuch">
                    Sales School Tickets
                  </span>
                  <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-655" data-mp="1b98dnuhanxlr">
                    $200
                  </span>
                </div>
                <p className="mt-1 text-right text-sm text-slate-400" data-id="element-656" data-mp="1gaxpvdg96hbf">per ticket</p>
                <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-657" data-mp="1kbzopt69crcv">
                  Purchased separately, up to a $5,000 monthly maximum.
                </p>
              </div>

              <div className="flex-1" data-id="element-658" data-mp="1u7b66j91wcob">
                <div className="text-sm font-bold text-white mb-3" data-id="element-659" data-mp="1u69mxrhvsjvi">What you get:</div>
                <ul className="space-y-2.5" data-id="element-660" data-mp="1z1ff381vmus1">
                  {['Custom ATS, application flow, and campaign creative', 'Active job board management and optimization', 'Applicant screening and pre-qualification', 'Candidate handoff to your internal team', 'Multi-market coordination and reporting'].map(item => <li key={item} className="flex items-start text-sm text-slate-300" data-id="element-661" data-mp="8vso03npj98h">
                      <Check className="w-4 h-4 text-slate-400 mr-2 mt-0.5 shrink-0" data-id="element-662" data-mp="mmdzv8equiwv" />
                      <span data-id="element-663" data-mp="hvxkhird4n7v">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-664" data-mp="wkbtycjab9xe">
                <p className="text-sm text-slate-400 leading-relaxed" data-id="element-665" data-mp="rlqwulzbx6d6">
                  <span className="text-white font-medium" data-id="element-666" data-mp="rlh5ov2jst5w">Best for:</span> teams
                  with strong internal hiring and onboarding who want more
                  predictable candidate flow.
                </p>
              </div>
            </motion.article>}

          {/* ADVANTAGE */}
          <div className="bg-slate-900/60 border border-[#7FE0C3]/40 rounded-2xl p-8 flex flex-col relative" data-id="element-667" data-mp="37ezbh6fk6ncf">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 py-1 bg-[#7FE0C3] text-[#163A5F] text-xs font-bold uppercase tracking-widest rounded-full" data-id="element-668" data-mp="32g6846tzkcpz">
              Most Teams Start Here
            </div>
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-669" data-mp="1948uqsjxlrh7">
              <div className="p-2 bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 rounded-lg" data-id="element-670" data-mp="1d514ro0mo0ej">
                <FileText className="w-6 h-6 text-[#7FE0C3]" data-id="element-671" data-mp="1d2ofepsjinrg" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-672" data-mp="z3yk9fpa6y5q">Advantage</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-673" data-mp="145nvavci7btt">
              We build and own the recruiting system, and your team runs the
              interviews. A predictable hiring engine with full accountability.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-674" data-mp="2kjnsvznvmpdw">
              <div className="flex items-end justify-between mb-5" data-id="element-675" data-mp="2kgi1uevotdfj">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-676" data-mp="2oiwm93f08l8x">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-677" data-mp="1ccozascz5chv">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-678" data-mp="17e3zuv5jqwuh">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-679" data-mp="12jq9x89nlhx7">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-680" data-mp="xk3waxpwxznv">$5,000</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-681" data-mp="ti09xe1phant">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-682" data-mp="onmkrtdmzzrl">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-683" data-mp="eodtj8a5oz8x">
                  <li className="flex justify-between" data-id="element-684" data-mp="2e0gc8gayhplj">
                    <span data-id="element-685" data-mp="2dxu34c8f3217">System fee</span>
                    <span data-id="element-686" data-mp="290v87rgxir1y">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-687" data-mp="2hi40k0wry3pb">
                    <span data-id="element-688" data-mp="2hhccdb5ib892">Campaign management</span>
                    <span data-id="element-689" data-mp="2ljh6eazva6w8">$2,500</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-690" data-mp="2qa5xhp7mx1uu">
              <div className="flex items-baseline justify-between gap-3" data-id="element-691" data-mp="2v9iv9501ntc7">
                <span className="text-xs font-bold uppercase tracking-widest text-[#7FE0C3]" data-id="element-692" data-mp="2v8r2e1xu09pm">
                  Sales School Tickets
                </span>
                <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-693" data-mp="22k3ahnikum33">
                  $150
                </span>
              </div>
              <p className="mt-1 text-right text-sm text-slate-400" data-id="element-694" data-mp="27m1152tb4j62">per ticket</p>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-695" data-mp="2cklzsxswuuse">
                Purchased separately, up to a $5,000 monthly maximum.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-696" data-mp="3nwd392fod08s">
              <div className="text-sm font-bold text-white mb-3" data-id="element-697" data-mp="38nibnc2wsp1o">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-698" data-mp="3dljv3y48yqdo">
                {['Custom ATS, landing pages, and full funnel build', 'Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Interview auditing and coaching to improve retention', 'Monthly recruiting review and ongoing consulting'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-699" data-mp="2uplfuhwa4mo2" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-700" data-mp="33ofj2r448bal" />
                    <span data-id="element-701" data-mp="dz3p1z40wz6g">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-702" data-mp="ix5b8swqxem5">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-703" data-mp="t1ver37ssqsh">
                <span className="text-white font-medium" data-id="element-704" data-mp="t13idq6dmp15">Best for:</span> teams
                that want recruiting to finally be consistent and predictable,
                while keeping interviews and final decisions in-house.
              </p>
            </div>
          </div>

          {/* SUMMIT */}
          <div className="bg-slate-900/40 border border-amber-500/30 rounded-2xl p-8 flex flex-col relative" data-id="element-705" data-mp="f8dwrmurfm4k">
            <div className="flex items-center space-x-3 mb-3 mt-2" data-id="element-706" data-mp="a90ze869iwnq">
              <div className="p-2 bg-amber-500/10 border border-amber-500/20 rounded-lg" data-id="element-707" data-mp="5appjxfywm5i">
                <Mountain className="w-6 h-6 text-amber-400" data-id="element-708" data-mp="dzbffnq40mq" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-709" data-mp="3shs4naw6itbu">Summit</h2>
            </div>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed" data-id="element-710" data-mp="1urqroy0k5ir5">
              Everything in Advantage, plus a dedicated US-based recruiter who
              runs your interviews. Recruiting execution handled entirely for
              you.
            </p>

            {/* Pricing */}
            <div className="mb-6" data-id="element-711" data-mp="3ozm8dwec6ckb">
              <div className="flex items-end justify-between mb-5" data-id="element-712" data-mp="3ozulnpedfjw1">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-713" data-mp="3b87n1iwyhza3">
                  Build (One-Time)
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-714" data-mp="3f9szx49hqdka">$6,500</span>
              </div>
              <div className="flex items-end justify-between" data-id="element-715" data-mp="6tzfiec1ghxy">
                <span className="text-xs text-amber-400 uppercase tracking-wider" data-id="element-716" data-mp="bssvqeipmn1t">
                  Total Monthly
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-717" data-mp="3txw4c97vxh6z">$7,500</span>
              </div>
              <div className="mt-3 rounded-lg bg-slate-950/40 border border-slate-800/60 px-4 py-3" data-id="element-718" data-mp="2qb8bwrbjod8">
                <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-2" data-id="element-719" data-mp="2ihpbrum2wrll">
                  What makes up the monthly
                </div>
                <ul className="space-y-1 text-xs text-slate-400 min-h-[3.5rem]" data-id="element-720" data-mp="2f0jorl1s5hwl">
                  <li className="flex justify-between" data-id="element-721" data-mp="2azrhgxcgxn2y">
                    <span data-id="element-722" data-mp="2ayyapwdiexkt">System fee</span>
                    <span data-id="element-723" data-mp="2oz0mr1z4yws5">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-724" data-mp="2oyhdsargriq9">
                    <span data-id="element-725" data-mp="2jzwce80h6t08">Campaign management</span>
                    <span data-id="element-726" data-mp="2jy32mjukfso0">$2,500</span>
                  </li>
                  <li className="flex justify-between" data-id="element-727" data-mp="1wbmtpeyk6ldb">
                    <span data-id="element-728" data-mp="1rbigpywv08ru">Corporate recruiter</span>
                    <span data-id="element-729" data-mp="1rctkhyqb1giy">$2,500</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800/50" data-id="element-730" data-mp="261pq7p4w2hge">
              <div className="flex items-baseline justify-between gap-3" data-id="element-731" data-mp="218n0js38fs5h">
                <span className="text-xs font-bold uppercase tracking-widest text-amber-400" data-id="element-732" data-mp="1djk9xuqmeoyu">
                  Sales School Tickets
                </span>
                <span className="text-2xl font-bold text-white whitespace-nowrap" data-id="element-733" data-mp="18iwnlmdc6way">
                  $100
                </span>
              </div>
              <p className="mt-1 text-right text-sm text-slate-400" data-id="element-734" data-mp="grxdf1gez9a3">per ticket</p>
              <p className="mt-3 text-xs text-slate-500 leading-relaxed" data-id="element-735" data-mp="kuk7za4gz8az">
                Purchased separately, up to a $5,000 monthly maximum.
              </p>
            </div>

            {/* Value */}
            <div className="flex-1" data-id="element-736" data-mp="ukn0783roi89">
              <div className="text-sm font-bold text-white mb-3" data-id="element-737" data-mp="ujlnz0b0lpoy">
                Everything in Advantage, plus:
              </div>
              <ul className="space-y-2.5" data-id="element-738" data-mp="zl1bcz0o08ai">
                {['A dedicated US-based corporate recruiter representing your brand', 'Second-round interview execution handled for you', 'Candidate scheduling and follow-up', 'Full execution accountability'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-739" data-mp="3abrokdf0sypp" data-mpi={i}>
                    <Check className="w-4 h-4 text-amber-400 mr-2 mt-0.5 shrink-0" data-id="element-740" data-mp="2y10ezycbf3gq" />
                    <span data-id="element-741" data-mp="2xz74u92hu13z">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-8 pt-6 border-t border-slate-800/50" data-id="element-742" data-mp="2p0c0z3mx933u">
              <p className="text-sm text-slate-400 leading-relaxed" data-id="element-743" data-mp="2p26jycemul5a">
                <span className="text-white font-medium" data-id="element-744" data-mp="3lpjim0kf6s2h">Best for:</span> teams
                whose leaders are too busy selling to interview, and want
                recruiting execution fully off their plate.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. SHARED NOTE */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-20" data-id="element-745" data-mp="37qbmxhngu231">
        <div className="p-5 bg-[#7FE0C3]/5 border border-[#7FE0C3]/20 rounded-lg" data-id="element-746" data-mp="21b143x8ozsuz">
          <p className="text-[#7FE0C3] text-center text-sm font-medium" data-id="element-747" data-mp="1wb5223jk2bi2">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 4. LEADERSHIP ADD-ON */}
      <section className="px-6 md:px-12 max-w-5xl mx-auto mb-24" data-id="element-748" data-mp="22r54yyw4wmrp">
        <div className="text-center mb-8" data-id="element-749" data-mp="1or3xh0ld6h39">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-[#7FE0C3]/10 border border-[#7FE0C3]/20 text-[#7FE0C3] text-xs font-bold uppercase tracking-widest mb-4" data-id="element-750" data-mp="1ouhxi26k2e7j">
            Optional Add-On
          </div>
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-751" data-mp="1jtkhnw90pw97">
            Add Leadership to Either Package
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto leading-relaxed" data-id="element-752" data-mp="1557k4uua85cl">
            Leadership is an optional add-on that layers onto Advantage or
            Summit. Run it in tandem with your main campaign, or ahead of it to
            put the right manager in place before you scale the team beneath
            them.
          </p>
        </div>

        {/* Visual: Advantage or Summit + Leadership */}
        <div className="flex flex-col sm:flex-row items-stretch justify-center gap-4 mb-10" data-id="element-753" data-mp="hhkgmapldknm">
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-slate-700 rounded-xl p-5 text-center" data-id="element-754" data-mp="cipvv382dm0v">
            <div className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-755" data-mp="qis9ued93vau">
              Core Package
            </div>
            <div className="text-white font-bold" data-id="element-756" data-mp="10fn94zhclzq6">Advantage or Summit</div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-757" data-mp="10dkajr24qy9u">
              Recruits and ramps your reps
            </div>
          </div>
          <div className="flex items-center justify-center text-slate-500" data-id="element-758" data-mp="1a56qu1tbrnjg">
            <Plus className="w-6 h-6" data-id="element-759" data-mp="1a79guluh9go6" />
          </div>
          <div className="flex-1 max-w-xs mx-auto sm:mx-0 bg-slate-900/40 border border-[#7FE0C3]/30 rounded-xl p-5 text-center" data-id="element-760" data-mp="157oj2er1ned1">
            <div className="text-xs text-[#7FE0C3] uppercase tracking-wider mb-1" data-id="element-761" data-mp="1j421pr7bdlt3">
              Add-On
            </div>
            <div className="text-white font-bold flex items-center justify-center" data-id="element-762" data-mp="2ljhgzl9b0ild">
              <Crown className="w-4 h-4 text-[#7FE0C3] mr-2" data-id="element-763" data-mp="2lltvfofusato" />
              Leadership
            </div>
            <div className="text-xs text-slate-500 mt-1" data-id="element-764" data-mp="2qkev9mr70shl">
              Recruits the managers who lead them
            </div>
          </div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-8" data-id="element-765" data-mp="2zhz2rdfnfl0n">
          <div className="flex flex-col md:flex-row gap-10" data-id="element-766" data-mp="22tssa9w1pyeg">
            <div className="flex-1" data-id="element-767" data-mp="26ul0czt6lx95">
              <div className="text-sm font-bold text-white mb-3" data-id="element-768" data-mp="26vmni2nh2a78">
                What you get:
              </div>
              <ul className="space-y-2.5" data-id="element-769" data-mp="2bswcjh6y8juj">
                {['Targeted outreach to experienced operators and team leaders', 'Interviews handled for you', 'Vetted candidates passed to you for final approval only', 'Performance aligned to the leader and their team output'].map((item, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-770" data-mp="1gjjagbmsm5t9" data-mpi={i}>
                    <Check className="w-4 h-4 text-[#7FE0C3] mr-2 mt-0.5 shrink-0" data-id="element-771" data-mp="1bjetkkhz392i" />
                    <span data-id="element-772" data-mp="16klcyj7e31y4">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="w-full md:w-72 shrink-0 space-y-4 md:border-l md:border-slate-800 md:pl-10" data-id="element-773" data-mp="12mw2zex7rx93">
              <div className="flex items-end justify-between" data-id="element-774" data-mp="xnjg4u6ceq6i">
                <span className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-775" data-mp="stf6221s6217">
                  Build (One-Time)
                </span>
                <span className="text-xl font-bold text-white" data-id="element-776" data-mp="iwu11gprgqxd">$1,000*</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-777" data-mp="ev8ro5cfqurx">
                *Must be built in conjunction with a standard campaign.
              </p>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-778" data-mp="9xgogf6cbm8f">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-779" data-mp="2ux1yg0jvx7jq">
                  Monthly Management
                </span>
                <span className="text-xl font-bold text-white" data-id="element-780" data-mp="2qunjhrjc6rxq">$2,500</span>
              </div>
              <div className="flex items-end justify-between pt-2 border-t border-slate-800/50" data-id="element-781" data-mp="2lzhvmn6dj370">
                <span className="text-xs text-[#7FE0C3] uppercase tracking-wider" data-id="element-782" data-mp="2h0evnh593n5w">
                  Performance
                </span>
                <span className="text-xl font-bold text-white" data-id="element-783" data-mp="277z9e7mx8cf7">2.5%</span>
              </div>
              <p className="text-xs text-slate-500 -mt-2" data-id="element-784" data-mp="236nr6n6dmth1">
                Of revenue, capped at $15,000. Based on the leader's personal
                and team production combined.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 5. HOW TO CHOOSE */}
      <section className="px-6 md:px-12 max-w-3xl mx-auto" data-id="element-785" data-mp="1o9ws6f0m7jry">
        <div className="text-center mb-10" data-id="element-786" data-mp="1oaev1uhs8w8u">
          <h2 className="text-3xl font-bold text-white mb-3" data-id="element-787" data-mp="1e67xs3n0qk0p">How to choose</h2>
          <p className="text-slate-400" data-id="element-788" data-mp="1j4sye466n5po">
            A quick way to land on the right fit for where your team is today.
          </p>
        </div>

        <div className="space-y-4" data-id="element-789" data-mp="1o578rsv9arqv">
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-790" data-mp="1o1t8cq65ksm2">
            <FileText className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-791" data-mp="1t0mlghhj2hlp" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-792" data-mp="vh1lozgqcqnv">
              <span className="text-white font-medium" data-id="element-793" data-mp="10fcxhfql5b8q">Choose Advantage</span>{' '}
              if your team can run interviews well and you mainly need a
              recruiting system that produces consistent, qualified candidates.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-amber-500/20 rounded-xl p-5" data-id="element-794" data-mp="coz2bgcpew9x">
            <Mountain className="w-5 h-5 text-amber-400 mr-4 mt-0.5 shrink-0" data-id="element-795" data-mp="hnk5non95w2l" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-796" data-mp="hlh4c8gnggik">
              <span className="text-white font-medium" data-id="element-797" data-mp="9ljivil862h6">Choose Summit</span> if
              interviewing is eating your leadership's time and you want a
              recruiter to handle execution end to end.
            </p>
          </div>
          <div className="flex items-start bg-slate-900/30 border border-[#7FE0C3]/20 rounded-xl p-5" data-id="element-798" data-mp="edug2dokza61">
            <Crown className="w-5 h-5 text-[#7FE0C3] mr-4 mt-0.5 shrink-0" data-id="element-799" data-mp="3mte6l4xvaehe" />
            <p className="text-slate-300 text-sm leading-relaxed" data-id="element-800" data-mp="3mvqoxj7jequz">
              <span className="text-white font-medium" data-id="element-801" data-mp="3hvuqs0littnc">Add Leadership</span> to
              either package when you also need to recruit the managers and team
              leaders who will scale your operation.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-802" data-mp="1c1cqdsxw4kc5">
          <p className="text-slate-500 text-sm max-w-xl mx-auto leading-relaxed" data-id="element-803" data-mp="1c01knnkvx2ie">
            Most partners start with Advantage as the foundation, then add
            Summit for execution or Leadership for management hiring as their
            needs grow.
          </p>
        </div>
      </section>
    </div>;
}